import { apiModule } from '@/helpers/utils';
import axios from 'axios';
const adminPrefix = apiModule.ADMINISTRATION;
const inboxPrefix = apiModule.INBOX;
const requestsPrefix = apiModule.REQUESTS;

const CancelToken = axios.CancelToken;
const cancelTokens = {};
export default {
  executeHttpRequest: ({ httpMethod, url, payload }) => axios[httpMethod](url, payload),
  getUserInfo: () => axios.get(`/api/user/me`),
  getSideNavItems: () => axios.get(`${inboxPrefix}/menu`),
  getNotificationsCount: () => axios.get(`${adminPrefix}/notifications/count`),
  getNotificationList: searchQuery => axios.get(`${adminPrefix}/notifications`, { params: searchQuery }),
  patchNotificationSeen: unseenList => axios.patch(`${adminPrefix}/notifications`, unseenList),
  putNotificationSeen: id => axios.put(`${adminPrefix}/notifications/${id}`),
  getDataGridItems: (endPointUrl, searchQuery) => {
    cancelTokens.getDataGridItems && cancelTokens.getDataGridItems();
    return axios.get(endPointUrl, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        cancelTokens.getDataGridItems = cancelFunction;
      }),
      params: searchQuery,
    });
  },
  getDataGridItemsForExcel: (endPointUrl, searchQuery) => {
    cancelTokens.getDataGridItemsForExcel && cancelTokens.getDataGridItemsForExcel();
    return axios.get(endPointUrl, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        cancelTokens.getDataGridItemsForExcel = cancelFunction;
      }),
      params: searchQuery,
    });
  },
  getDashboardChartData: ({ endpoint, searchQuery, withModulePrefix }) => {
    const endpointUrl = withModulePrefix ? endpoint : `${requestsPrefix}${endpoint}`;
    return axios.get(`${endpointUrl}`, { params: searchQuery });
  },
  getDashboards: () => axios.get(`${inboxPrefix}/dashboards`),
  getDynamicForms: () => axios.get(`${inboxPrefix}/forms`, {
    params: {
      pageIndex: 0,
      pageSize: 999999,
    },
  })
    .then(res => res.data.list),
  addDynamicForm: payload => axios.post(`${inboxPrefix}/forms`, payload),
  getDynamicForm: id => axios.get(`/app/inbox/api/forms/${id}`),
  addOrUpdateResponseForm: payload => axios.post(`${inboxPrefix}/forms/response-form`, payload),
  getDynamicFormFields: id => axios.get(`${inboxPrefix}/forms/${id}/fields`),
  getDynamicFormFlatFields: payload => axios.get(`${inboxPrefix}/forms/${payload.id}/flat-fields`, {
    skipCancelToken: true,
    params: {
      types: payload.types,
      serializer: 'repeat',
    },
  }),
  editDynamicForm: (payload, id) => axios.put(`${inboxPrefix}/forms/${id}`, payload),
  getDynamicGrids: () => axios.get(`${inboxPrefix}/grids`, {
    params: {
      pageIndex: 0,
      pageSize: 999999,
    },
  })
    .then(res => res.data.list),
  getDynamicGridsHasForms: () => axios.get(`${inboxPrefix}/grids`, {
    params: {
      isFormRelated: true,
      pageIndex: 0,
      pageSize: 999999,
    },
  })
    .then(res => res.data.list),
  getDynamicGrid: (id) => {
    cancelTokens.getDataGridItems && cancelTokens.getDataGridItems();
    cancelTokens.getDynamicGrid && cancelTokens.getDynamicGrid();
    return axios.get(`${inboxPrefix}/grids/${id}`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        cancelTokens.getDynamicGrid = cancelFunction;
      }),
    });
  },
};
